import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import store from './redux/store';
import { BrowserRouter as Router } from 'react-router-dom';
import Views from './views';
import { Route, Switch } from 'react-router-dom';
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { THEME_CONFIG } from './configs/AppConfig';
import { AUTH_TOKEN } from './redux/constants/Auth';

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

const LTI_AUTO_LOGOUT_FLAG = 'lti_auto_logout';

function App() {
  useEffect(() => {
    const handleLtiTabClose = () => {
      const isLtiSession = sessionStorage.getItem(LTI_AUTO_LOGOUT_FLAG) === '1';
      if (!isLtiSession) return;

      // Cleanup local auth artifacts for LTI-only sessions on tab close.
      localStorage.removeItem(AUTH_TOKEN);
      localStorage.removeItem('PRIMARY_DATA');
      localStorage.removeItem('SECONDARY_DATA_NAME');
      localStorage.removeItem('SECONDARY_SUBMENU');
      localStorage.removeItem('projectRef');
      localStorage.removeItem('usuario');
      localStorage.removeItem('auth_email');
      localStorage.removeItem('user_role');
      localStorage.removeItem('user_name');
      sessionStorage.removeItem(LTI_AUTO_LOGOUT_FLAG);
      sessionStorage.removeItem('lti_claims');
    };

    window.addEventListener('beforeunload', handleLtiTabClose);
    window.addEventListener('pagehide', handleLtiTabClose);

    return () => {
      window.removeEventListener('beforeunload', handleLtiTabClose);
      window.removeEventListener('pagehide', handleLtiTabClose);
    };
  }, []);

  return (
    <div className="App">
      <Provider store={store}>
        <ThemeSwitcherProvider themeMap={themes} defaultTheme={THEME_CONFIG.currentTheme} insertionPoint="styles-insertion-point">
          <Router>
            <Switch>
              <Route path="/" component={Views}/>
            </Switch>
          </Router>
        </ThemeSwitcherProvider>
      </Provider>
    </div>
  );
}

export default App;
